import request from '@/service/request'

 /* 生成一次性密码
   * @param {*} params
   * @param {*} params.deviceId 门锁的deviceId
   * @returns
    */
const addSingleKey = (params) => {
  return request.post('/rent/yjylock/addSingleKey', params)
}

/* 新门锁房间遍历(并新增新的门锁信息)
   * @returns
    */
const roomTraversal = (params) => {
  return request.post('/rent/yjylock/roomTraversal', params)
}

/* 刷新组织下单组织的门锁信息
   * @param {*} params
   * @param {*} params.id 房间的id
   * @returns
    */
const refreshRoomByApartmentId = (params) => {
  return request.post(`/rent/yjylock/refreshRoomByApartmentId/${params.id}`)
}

/* 获取寓家小区账号下的所有发卡器信息
   * @param {*} params
   * @param {*} params.pageNum 页码
   * @param {*} params.pageSize 每页数量
   * @param {*} params.tokenId 寓家API账号的tokenid（getSubTokenId获取）
   * @returns
    */
const apartmentGetCreditList = (params) => {
  return request.post('/rent/yjylock/apartmentGetCreditList', params)
}

/* 绑定寓家小区账号下的发卡器
   * @param {*} params
   * @param {*} params.deviceSeq 发卡器的码
   * @param {*} params.tokenId 奥家API账号的tokenid（getSubTokenId获取）
   * @returns
    */
const apartmentBindingCredit = (params) => {
  return request.post('/rent/yjylock/apartmentBindingCredit', params)
}

/* 获取寓家小区账号下的子tokenid
   * @param {*} params
   * @param {*} params.accountName 寓家API账号名称
   * @param {*} params.password 寓家API账号密码
   * @returns
    */
const getSubTokenId = (params) => {
  return request.post('/rent/yjylock/getSubTokenId', params)
}

export {
  addSingleKey,
  roomTraversal,
  refreshRoomByApartmentId,
  apartmentGetCreditList,
  apartmentBindingCredit,
  getSubTokenId
}
